import WebServiceRequest from "@/libs/Api/WebServiceRequest";

class CreateArvanVideo extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("ArvanCloudVideo/Create");
  }
  setRequestParam(data) {
    super.setRequestParam(data);
  }
}

class UpdateArvanVideoStatus extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("ArvanCloudVideo/UpdateStatusInCompleteVideos");
  }
}

class DeleteArvanVideo extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("ArvanCloudVideo/Delete");
  }
  setRequestParam(data) {
    super.setRequestParam(data);
  }
}

export { CreateArvanVideo, UpdateArvanVideoStatus, DeleteArvanVideo };
